import { Pagination, TablePaginationConfig } from "antd";
import Select from "../inputs/select";
import { Text } from "../text";

export const PaginationToolbar: React.FC<{
  total?: number;
  pagination: TablePaginationConfig;
  setPagination: (arg: TablePaginationConfig) => void;
}> = ({ total = 0, pagination, setPagination,  ...rest }) => (
  <group>
    {total > 0 && (
      <group
        data-align="center"
        data-space="5"
        data-border=""
        data-gap="10"
        {...rest}
      >
        <Pagination
          size="small"
          {...pagination}
          simple={false}
          showSizeChanger={false}
          total={total}
          onChange={(current) => {
            setPagination({ ...pagination, current });
          }}
        />

        <label data-type="group" data-interactive="" data-width="auto" data-align="center" data-wrap="no" data-radius="5"  data-cursor="pointer" >

          <Text light  data-space-horizontal="5">size</Text>

          <Select
           
            suffixIcon={null}
            borderLess
            showAction={["focus"]}
            popupMatchSelectWidth={false}
            //bordered={false}
            variant="borderless"
            options={[10, 25, 50, 100, 200, 500]}
            value={pagination.pageSize}
            onChange={(value: any) => {
              setPagination({ ...pagination, pageSize: value });
            }}
          />
        </label>
        <separator data-height="20"
          data-vertical=""
        ></separator>

        <Text light>total</Text>
        <Text>{total}</Text>
      </group>
    )}
  </group>
);
